import AdvancedSelect from "@edaz/edazkit/controls/AdvancedSelect";
import { Input } from "@frui.ts/bootstrap";
import DateRangeInputControl from "controls/dateRangeInput";
import AccountNumberOrIbanAndBankCodeInput from "controls/finance/accountNumberOrIbanAndBankCodeInput";
import { observer } from "mobx-react-lite";
import React from "react";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import { translateGeneral } from "utils/localizations";
import { onNumberInputKeyPress } from "utils/numberInput";
import type PairingByOrderPaymentsListViewModel from "viewModels/finance/paymentsPairing/pairingByOrder/pairingByOrderPaymentsListViewModel";
import type PairingByPaymentListViewModel from "viewModels/finance/paymentsPairing/pairingByPayment/pairingByPaymentListViewModel";
import FilterView from "../../common/filter";

export interface PaymentFiltersProps {
  vm: PairingByPaymentListViewModel | PairingByOrderPaymentsListViewModel;
}

const PaymentFilters = observer((props: PaymentFiltersProps) => {
  const { vm } = props;

  return (
    <FilterView vm={vm}>
      <div className="row">
        <Form.Group as={Col} md={6} lg={4} xl={3}>
          <Form.Label>{vm.translateAttribute("senderBankAccount")}</Form.Label>
          <AccountNumberOrIbanAndBankCodeInput
            target={vm.filter}
            property="bankAccount"
            mode="object"
            placeholder={translateGeneral("search")}
          />
        </Form.Group>
        <Form.Group as={Col} md={6} lg={4} xl={3}>
          <Form.Label>{vm.translateAttribute("variableSymbol")}</Form.Label>
          <Input
            target={vm.filter}
            property="variableSymbol"
            placeholder={translateGeneral("search")}
            type="number"
            onKeyDown={onNumberInputKeyPress}
          />
        </Form.Group>
        <Form.Group as={Col} md={6} lg={4} xl={3}>
          <Form.Label>{vm.translateAttribute("constantSymbol")}</Form.Label>
          <Input target={vm.filter} property="constantSymbol" placeholder={translateGeneral("search")} type="number" />
        </Form.Group>
        <Form.Group as={Col} md={6} lg={4} xl={3}>
          <Form.Label>{vm.translateAttribute("specificSymbol")}</Form.Label>
          <Input target={vm.filter} property="specificSymbol" placeholder={translateGeneral("search")} type="number" />
        </Form.Group>
        <Form.Group as={Col} md={6} lg={4} xl={3}>
          <Form.Label>{vm.translateAttribute("paidAmount")}</Form.Label>
          <Input target={vm.filter} property="paidAmount" step={0.01} placeholder={translateGeneral("search")} type="number" />
        </Form.Group>
        <Form.Group as={Col} lg={8} xl={6}>
          <Form.Label>{vm.translateAttribute("postingDate")}</Form.Label>
          <DateRangeInputControl target={vm.filter} property="postingDate" />
        </Form.Group>
        <Form.Group as={Col} md={6} lg={4} xl={3}>
          <Form.Label>{vm.translateAttribute("status")}</Form.Label>
          <AdvancedSelect
            target={vm.filter}
            property="status"
            items={vm.stateOptions}
            allowEmpty={true}
            placeholder={translateGeneral("select")}
          />
        </Form.Group>
        <Form.Group as={Col} md={6} lg={4} xl={3}>
          <Form.Label>{vm.translateAttribute("messageForRecipient")}</Form.Label>
          <Input target={vm.filter} property="messageForRecipient" placeholder={translateGeneral("search")} />
        </Form.Group>
      </div>
    </FilterView>
  );
});

export default PaymentFilters;
